<template>
  <div class="no-con-wrap">
    <img src="/static/noContent.png" class="no-img">
    <div class="no-content">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: 'ContentEmpty',
  props: {
    content: String
  }
}
</script>

<style lang="stylus" scoped>
.no-img
  display block
  width 2rem
  height 2rem
  margin 1.4rem auto 0

.no-content
  font-size 0.26rem
  color #dddddd
  text-align center
  margin-top 0.4rem
</style>



// WEBPACK FOOTER //
// src/components/ContentEmpty.vue